export default "__VITE_ASSET__Dh9$3Ubl__"